function hasText(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Pure gate for the TARA Writing "one response only" rule: once any of the
 * three expanded prompts holds non-empty text, every other prompt must
 * refuse new non-empty text. Must be called before every write into a
 * writing item's text_response — typed input, Paste, Cut, Undo, and Redo —
 * not just the main change handler, or Undo/Redo can silently paste one
 * prompt's draft onto another's virtual id.
 *
 * @param {string} proposedText - the text about to be written
 * @param {string} targetId - virtual id of the prompt being written to
 * @param {Record<string, {text_response?: string}>} userAnswers - current answers keyed by virtual id
 * @param {string[]} siblingIds - virtual ids of the other prompts sharing this question's db_id
 * @returns {{ block: boolean }}
 */
export function taraWritingOneResponse(proposedText, targetId, userAnswers, siblingIds) {
  if (!hasText(proposedText)) return { block: false };

  const others = (siblingIds || []).filter((id) => id !== targetId);
  const anotherHasText = others.some((id) => hasText(userAnswers?.[id]?.text_response));

  return { block: anotherHasText };
}
